/** OWA-998: button labels shared by the held-save notice, the editor banner, Needs Attention and TaskMerge. */
export const VIEW_THE_NEW_TASK = 'View the New Task';
export const MERGE = 'Merge';
export const RESTORE_WITH_MY_CHANGES = 'Restore It with My Changes';
export const ABANDON = 'Abandon';
